<template>
  <div>
    <b-modal id="staffPosition" title="Staff Position" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Staff Setting
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <table>

          <tr>
            <th></th>
            <th style="text-align: center;">Position</th>
            <th style="text-align: center;">Basic Salary</th>
            <th style="text-align: center;">Allowance</th>
          </tr>

          <tr class="form-group" v-for="(staff, index) in selectedStaffs" :key="'staff_' + index">
            <td>
              <label class="form-label">{{ staff['name'] }}</label>
            </td>
            <td>
              <multiselect
                v-model="position[staff['id']]"
                @select="multiselectChange"
                :options="positions"
                :searchable="false"
                :show-labels="false"
                openDirection="below">
                <template slot="option" slot-scope="{ option }">{{ option }}</template>
              </multiselect>
            </td>
            <td>
              <input v-model="basic[staff['id']]" class="form-control" placeholder="Basic Salary" type="number">
            </td>
            <td>
              <input v-model="allowance[staff['id']]" class="form-control" placeholder="Allowance" type="number">
            </td>
          </tr>

        </table>

      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "staffPosition",
  data() {
    return {
      showLoading: false,
      outlets: [],
      positions: ['护理师', '设计师', '顾问', '店长'],
      // positions: ['护理师', '设计师', '顾问', '店长', '全职顾问', '全职设计师', '合约设计师'],
      staffs: [],
      selectedStaffs: [],

      selectedOutlet: {},
      data: {},

      position: {},
      basic: {},
      allowance: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('staffPosition')
      this.loadStaff()
    },

    onOutletChange() {
      // Object.assign(this.data, {})
      this.data = {}
      this.join = {}
      this.probation = {}

      this.selectedStaffs = []
      for (let staff of this.staffs) {
        if (this.selectedOutlet.id === staff['outletID']) {
          this.selectedStaffs.push({ id: staff['staffID'], name: staff['name'] + ' - ' + staff['mobile'], outletID: staff['outletID'] })

          this.data[staff['staffID']] = {
            join: '',
            probation: '',
          }
          this.join[staff['staffID']] = ''
          this.probation[staff['staffID']] = ''
        }
      }

      this.loadCommission()
    },

    loadStaff() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://staff.tunai.io/business/staff',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.staffs = response.data.staffs
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_PhiloHeadspa_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_PhiloHeadspa_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          response.data = response.data || {}
          // this.data = response.data
          for (let temp in response.data) {
            this.position[temp] = response.data[temp]['position']
            this.basic[temp] = response.data[temp]['basic']
            this.allowance[temp] = response.data[temp]['allowance']
          }

          this.$forceUpdate()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = {}
      for (let key in this.position) {
        request[key] = request[key] || {}
        request[key]['position'] = this.position[key]
      }
      for (let key in this.basic) {
        request[key] = request[key] || {}
        request[key]['basic'] = this.basic[key]
      }
      for (let key in this.allowance) {
        request[key] = request[key] || {}
        request[key]['allowance'] = this.allowance[key]
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_PhiloHeadspa_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_PhiloHeadspa_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('staffPosition')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    multiselectChange() {
      console.log(1)
      this.$forceUpdate()
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>